import { Box, Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import FeeTable from '../FeeTable';
import './style.scss';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { API } from '../../utils/apiEndpoint';

interface DateRangeFilterProps {
  fundId: string;
}

const minDate = dayjs('2026-01-01');
export default function DateRangeFilter({ fundId }: DateRangeFilterProps) {
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [toDate, setToDate] = useState<Dayjs | null>(null);
  const [data, setData] = useState<any[]>([]);

  // Convert dd/mm/yyyy to Date object
  // const parseDate = (dateStr: string) => {
  //   const [day, month, year] = dateStr.split('/');
  //   return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  // };

  const getFundFeesByDate = useCallback((fromDate: Dayjs | null, toDate: Dayjs | null) => {
    if (!fromDate || !toDate) {
      return;
    }
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    console.log(fromDate, toDate);
    const raw = JSON.stringify({
      "fundId": fundId,
      "fromDate": fromDate.format("DD/MM/YYYY"),
      "toDate": toDate.format("DD/MM/YYYY")
    });

    const requestOptions: any = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(API.fundFees, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to getFundFeesByDate");
        }
        return response.json();
      })
      .then((result) => setData(result.managementFee || []))
      .catch((error) => console.error(error));
  }, [fundId]);

    useEffect(() => {
      getFundFeesByDate(fromDate, toDate);
      // const intervalGetFundPerYear = setInterval(() => {
      //   getFundFeesByDate();
      // }, Constant.interval);
      return () => {
        // clearInterval(intervalGetFundPerYear);
      };
    }, [getFundFeesByDate, fromDate, toDate]);

  return (
    <Box className="date-range-filter">
      <Grid container spacing={3} className="date-inputs">
        <Grid size={{ xs: 6 }}>
          <DemoItem label="Từ">
            <DatePicker
              value={fromDate}
              onChange={(newValue) => {
                setFromDate(newValue);
                console.log('fromDate', fromDate);
              }}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      borderColor: "#ddd",
                      color: "#666",
                      fontSize: "12px",
                      minWidth: "100px",
                      height: "32px",
                    },
                  },
                },
              }}
              minDate={minDate}
              maxDate={toDate ? toDate : undefined}
            />
          </DemoItem>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <DemoItem label="Đến">
            <DatePicker
              value={toDate}
              onChange={(newValue) => {
                setToDate(newValue);
              }}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      borderColor: "#ddd",
                      color: "#666",
                      fontSize: "12px",
                      minWidth: "100px",
                      height: "32px",
                    },
                  },
                },
              }}
              minDate={fromDate ? fromDate : minDate}
            />
          </DemoItem>
        </Grid>
      </Grid>

      <FeeTable
        headers={[
          "Ngày kết thúc giao dịch",
          "Phí quản lý quỹ (%/năm)"
        ]}
        fees={data}
        fieldName="fundEffDate"
        valueField="fundValue"
        showFundNameColumn={true}
      />
    </Box>
  );
}
